import { createApiService } from "@/core/api/apiService";
import type { SubscriptionDto, SubscriptionSku } from "../types/subscriptionTypes";

export function createSubscriptionApiService() {
  const api = createApiService("businesses");
  return {
    getByBusinessId: (businessId: string, signal?: AbortSignal) =>
      api.get<SubscriptionDto>(`/${businessId}/subscription`, { signal }),
    createCheckout: (businessId: string, dto: { sku: SubscriptionSku }) =>
      api.post<{ url: string }>(`/${businessId}/subscription/checkout`, dto),
    createPortal: (businessId: string) =>
      api.post<{ url: string }>(`/${businessId}/subscription/portal`),
  };
}
export const subscriptionApiService = createSubscriptionApiService();
